import { FC } from 'react'
import cx from 'classnames'

import * as SC from './styled'

export type AdsStatusProps = {
  className?: string
  label: string
  status: string
}

const AdsStatus: FC<AdsStatusProps> = ({ className, label, status }) => {
  return (
    <SC.AdsStatus className={cx('AdsStatus', className)}>
      <SC.Label>{label}</SC.Label>
      <SC.Status>{status}</SC.Status>
    </SC.AdsStatus>
  )
}

export default AdsStatus
